if (!customElements.get('shipping-estimate')) {
  customElements.define('shipping-estimate', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('form').addEventListener('submit', event => this.calculate(event));
      // Cart quantity updates invalidate a previous quote.
      if (typeof subscribe === 'function') this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.run = (this.run || 0) + 1;
        this.querySelector('[data-shipping-result]').replaceChildren();
        this.querySelector('button').disabled = false;
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); this.run = (this.run || 0) + 1; }
    async calculate(event) {
      event.preventDefault();
      const button = this.querySelector('button');
      if (button.disabled) return;
      const output = this.querySelector('[data-shipping-result]');
      const params = new URLSearchParams({'shipping_address[zip]': this.querySelector('[name="zip"]').value.trim(), 'shipping_address[country]': 'Denmark'});
      const run = this.run = (this.run || 0) + 1;
      button.disabled = true; output.textContent = this.dataset.loading;
      try {
        const prepare = await fetch(`${this.dataset.root}cart/prepare_shipping_rates.json?${params}`, {method: 'POST', headers: {'Accept':'application/json'}});
        if (!prepare.ok) throw new Error('prepare');
        let data = null;
        for (let attempt = 0; attempt < 10; attempt++) {
          if (!this.isConnected || this.run !== run) return;
          const response = await fetch(`${this.dataset.root}cart/async_shipping_rates.json?${params}`, {headers: {'Accept':'application/json'}});
          if (!response.ok) throw new Error('rates');
          data = await response.json();
          if (data !== null) break;
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        if (!this.isConnected || this.run !== run) return;
        if (!Array.isArray(data?.shipping_rates)) throw new Error('timeout');
        output.replaceChildren();
        if (!data.shipping_rates.length) { output.textContent = this.dataset.empty; return; }
        const list = document.createElement('ul');
        for (const rate of data.shipping_rates) {
          const price = Number(rate.price);
          if (!Number.isFinite(price) || price < 0) throw new Error('invalid rate');
          const item = document.createElement('li');
          item.textContent = `${rate.presentment_name || rate.name}: ${new Intl.NumberFormat(this.dataset.locale, {style:'currency',currency:rate.currency || this.dataset.currency}).format(price)}`;
          list.append(item);
        }
        output.append(list);
      } catch { if (this.run === run) output.textContent = this.dataset.error; }
      finally { if (this.run === run) button.disabled = false; }
    }
  });
}
